import { inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
// ENUM

// Service

// Interface
import { IDataPagination, IPagination } from '@/interface/general/IPagination';
import { ITable, TypeColumn, TypeFormat } from '@/interface/general/ITable';
import { IServerSide } from '@/shared/components/general/table-generic/interface/table-generic.interface';

// Export Excel
import { environment } from 'src/environments/environment';

import { SendMailService } from './send-mail.service';
import {
  IServerSideBackend,
  IUpdateAttachementSelect,
} from '../interface/send-mail.interface';
import { HttpParams } from '@angular/common/http';
import { HttpService } from '@/Services/http.service';
import { IResponseApiSS } from '@/interface/general/IResponseApi';
import { Export } from '@/util/exportExcel';
import { CheckboxChangeEvent } from 'primeng/checkbox';

@Injectable({
  providedIn: 'root',
})
export class TableService {
  // EXPORT EXCEL
  registerSelectedToExportExcel: any;
  tableSubject: any = {};
  currentPagination!: IPagination;
  totalRecords = 0;
  dataTableGenericSubject$ = new Subject<IDataPagination<IServerSide>>();

  // VRIABLES DE TAB MAIL
  currentMailId = 0;

  rowsPerPageOptions = environment.paginationSmall;
  rowsPerPage = this.rowsPerPageOptions[0];

  private httpService = inject(HttpService);
  public service = inject(SendMailService);
  //URL
  private urlGetFileTabla = 'mail/GetListAttach';

  //#region LOAD TABLE
  setTable() {
    const table: ITable = {
      fieldId: 'Id',
      paginator: true,
      rowsPerPageOptions: this.rowsPerPageOptions,
      lazyLoadOnInit: true,
      columns: [
        {
          field: 'Id',
          label: '',
          type: TypeColumn.CHECK,
          action: (rowData: any, event: CheckboxChangeEvent) =>
            this.handleAction(rowData, event),
        },
        {
          field: 'Mil_IdMail',
          label: 'Id Mail',
          type: TypeColumn.NUMBER,
          filter: false,
          sort: false,
        },
        {
          field: 'NombreArchivo',
          label: 'Archivo',
          type: TypeColumn.STRING,
          filter: true,
          sort: false,
          format: TypeFormat.UPPERCASE,
        },
        {
          field: 'FechaRegistro',
          label: 'F. Registro',
          type: TypeColumn.DATE,
          filter: true,
          sort: true,
          format: TypeFormat.DATETIME,
        },
        {
          field: 'FechaRegistroUpdate',
          label: 'F. Registro actualizada',
          type: TypeColumn.DATE,
          filter: true,
          sort: true,
          format: TypeFormat.DATETIME,
        },
      ],
    };
    this.tableSubject = table;
  }

  handleAction(rowData: any, event: CheckboxChangeEvent) {
    this.onSelectedRecords(rowData.Id, event.checked);
  }

  //#region LOAD TABLE
  async onLoadRecords(event?: any) {
    this.currentPagination = event;

    let serverSide: IServerSide;

    if (!event) {
      // Primera carga de la tabla
      serverSide = {
        first: 0,
        rows: this.rowsPerPage,
        sortField: '',
        sortOrder: 0,
        filters: {},
        globalFilter: null,
      };
    } else {
      // Evento de paginación/filtro/ordenación
      const { first, rows, sortOrder, sortField, filters, globalFilter } =
        event;

      serverSide = {
        first: first,
        rows: rows,
        sortField: sortField,
        sortOrder: sortOrder,
        filters: filters,
        globalFilter: globalFilter,
      };
    }

    // Parámetros adicionales (con Mil_IdMail quemado a 25)
    const paramsFromFilterComponente = {
      Mil_IdMail: this.currentMailId.toString(), // Valor quemado
    };

    // ESTA CONSTANTE NO SE MODIFICA
    const paramsObject: IServerSideBackend = {
      ...paramsFromFilterComponente,
      ServerSide: serverSide,
      ExportExcel: false,
    };

    const httpParams = this.convertToHttpParams(paramsObject);
    this.callHttpService(httpParams);
  }


  private callHttpService(httpParams: HttpParams) {
    try {
      this.httpService.GetParams(this.urlGetFileTabla, httpParams).subscribe({
        next: (resp: IResponseApiSS) => {
          const { data, metadataServerSide } = resp;
          const datosTablaGenericConsultada: IDataPagination<IServerSide> = {
            data: data,
            pagination: {
              first:
                metadataServerSide?.numeroPagina *
                metadataServerSide.filasxPagina,
              rows: metadataServerSide.filasxPagina,
            },
            totalRecords: metadataServerSide?.totalRegitros,
          };
          this.registerSelectedToExportExcel = datosTablaGenericConsultada.data;
          this.dataTableGenericSubject$.next(datosTablaGenericConsultada);
        },
        error: (error) => {
        },
      });
    } catch (error) {
    }
  }

  /**
   * Metodo para exportar registros a excel
   */
  onExportSelectedExcel() {
    Export.Excel(
      this.registerSelectedToExportExcel ?? [],
      'Reporte_Alertas.xlsx'
    );
  }

  private convertToHttpParams(params: IServerSideBackend): HttpParams {
    let httpParams = new HttpParams();

    // Propiedades directas (con valores por defecto)
    httpParams = httpParams.append('Mil_IdMail', params.Mil_IdMail ?? '25');
    httpParams = httpParams.append(
      'ExportExcel',
      String(params.ExportExcel ?? false)
    );

    // ESTO NO SE MODIFICA
    if (
      params.ServerSide &&
      params.ServerSide.filters &&
      typeof params.ServerSide.filters === 'object' &&
      (params.ServerSide.filters as { global?: unknown }).global !== undefined
    ) {
      delete (params.ServerSide.filters as { global?: unknown }).global;
    }

    // Agregar parámetro ServerSide (ya está como string JSON)
    if (params.ServerSide) {
      httpParams = httpParams.append(
        'ServerSide',
        JSON.stringify(params.ServerSide)
      );
    }

    // Agregar parámetro booleano
    httpParams = httpParams.append(
      'ExportExcel',
      params.ExportExcel.toString()
    );

    return httpParams;
  }

  //#endregion

  //#region Check

  onSelectedRecords(Id: number, checked: boolean) {
    const data: IUpdateAttachementSelect = {
      Id: Id,
      Seleccionado: checked,
    };
    this.service.putAttachementSelect(data).subscribe((resp) => {
    });
  }
  //#endregion
}
